import styled from '@emotion/styled'
import { baseLayout } from '../../constants/theme'

export const Footer = styled('div')(({ collapsed, theme }) => ({
  left: collapsed
    ? `${baseLayout.sidebarCollapsedWidth} !important`
    : baseLayout.sidebarWidth,
  padding: `calc(${baseLayout.gridGutterWidth} / 2)`,
  right: '0',
  position: 'absolute',
  color: baseLayout.brandColorOrange,
  height: baseLayout.footerHeight, // `calc(${theme.footerHeight} - 20px)`,
  backgroundColor: theme.footerBg,
  textAlign: 'center',
  fontSize: '0.8125rem',
  '@media (max-width: 991.98px)': {
    left: collapsed
      ? '0  !important'
      : `${baseLayout.sidebarCollapsedWidth} !important`,
  },
  '@media print': {
    display: 'none !important',
  },
}))

export const FooterContent = styled('span')(({ theme }) => ({
  color: theme.footerSpanColor,
}))
